import {Formik} from 'formik';

import {FormComponent} from './FormComponent';

import {RecordSchema} from './RecordSchema';

import {FormWithButtons} from '@flexinet/ui-components';

import {
    Phase,
    PhaseRecordFormProps
} from '../types';
import {stage} from "../../../config/stage";

export const RecordForm = (
    {
        record,
        handleSubmit,
        handleCancel
    }: PhaseRecordFormProps) => {

    const onSubmit = (values: Phase) => {
        handleSubmit(values);
    };


    let initialValues = {} as Phase;

    if (record) {
        initialValues = Object.assign({}, initialValues, record);
    }

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={RecordSchema}
            onSubmit={onSubmit}
        >
            {({
                  handleSubmit,
                  isSubmitting,
                  ...rest
              }) => (
                <FormWithButtons handleSubmit={handleSubmit} isSubmitting={isSubmitting}
                                 handleCancel={handleCancel} debug={false && stage === 'ide'} {...rest}  >
                    <FormComponent/>
                </FormWithButtons>)}
        </Formik>
    );
};
